import { skipToken } from "@reduxjs/toolkit/query";
import { useEffect } from "react";
import { useNavigate, useParams, generatePath } from "react-router-dom";

import { useQuicksightReportQuery } from "api/memberPortal/reports/quicksight/quicksight.api";

// Currently only the ID is actually needed for the report lookup,
// this allows us to use just reports/:id and have it redirect to the
// human friendly route
const DashboardRedirect = () => {
  const { id, dashboardSlug } = useParams();
  const navigate = useNavigate();

  const { data: dashboard } = useQuicksightReportQuery(id ?? skipToken);

  useEffect(() => {
    if (id && dashboard) {
      // NOTE: Hardcoding until we can cleanup breadcrumbs
      const redirectPath = generatePath(
        "/community/reports/:id/:dashboardSlug",
        {
          id,
          dashboardSlug: dashboard.slug,
        },
      );
      navigate(redirectPath, { replace: true });
    }
  }, [id, navigate, dashboard, dashboardSlug]);

  return null;
};
export default DashboardRedirect;
